import {useEffect, useState} from 'react';

import {useTour} from '@reactour/tour';
import {EventCreationMode} from 'src/modules/event-create/constants';
import {isAiTourSuppressed} from 'src/openapi/apis/AiTourControllerApi';
import {TourType} from 'src/openapi/models/TourType';
import {useAppDispatch} from 'src/store';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

export const useAiTour = () => {
    const dispatch = useAppDispatch();
    const {setIsOpen} = useTour();
    const {onCreateNote} = usePushNotification();
    const [mode, setMode] = useState<EventCreationMode>();

    useEffect(() => {
        const fetchData = async () => {
            if (mode) {
                const tourType = mode.toUpperCase() as TourType;
                const response = await dispatch(isAiTourSuppressed({tourType}));

                if (response.payload?.success) {
                    const isSuppressed = Boolean(response.payload.data);
                    setIsOpen(!isSuppressed);
                }

                if (response.payload?.error) {
                    onCreateNote({
                        id: 'isAiTourSuppressedError',
                        status: Status.ERROR,
                        message: response.payload.data?.message,
                        buttonProps: {iconProps: {type: Icons.CLOSE}},
                        autoHideTimeout: 10000,
                    });
                }
            }
        };

        const timer = setTimeout(() => {
            fetchData();
        }, 1000);

        return () => clearTimeout(timer);
    }, [dispatch, mode, onCreateNote, setIsOpen]);

    return {setMode};
};
